import { render } from "./WaveformVerifyDialog.vue?vue&type=template&id=f0503b5c&scoped=true&ts=true"
import script from "./WaveformVerifyDialog.vue?vue&type=script&lang=ts"
export * from "./WaveformVerifyDialog.vue?vue&type=script&lang=ts"

import "./WaveformVerifyDialog.vue?vue&type=style&index=0&id=f0503b5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0503b5c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpinnerDots,QCardActions,QBtn});
